export interface RateLimitConfig {
  windowMs?: number;
  maxRequests?: number;
}

interface ClientRecord {
  requests: number;
  resetTime: number;
}

export class RateLimiter {
  private windowMs: number;
  private maxRequests: number;
  private clients: Map<string, ClientRecord> = new Map();

  constructor(config?: RateLimitConfig) {
    this.windowMs = config?.windowMs || 60000; // 1 minute
    this.maxRequests = config?.maxRequests || 100;

    // 定期清理过期记录
    setInterval(() => this.cleanup(), this.windowMs);
  }

  allow(clientIp: string): boolean {
    const now = Date.now();
    const client = this.clients.get(clientIp);

    if (!client || now > client.resetTime) {
      // 新客户端或窗口已过期
      this.clients.set(clientIp, {
        requests: 1,
        resetTime: now + this.windowMs,
      });
      return true;
    }

    if (client.requests >= this.maxRequests) {
      return false;
    }

    client.requests++;
    return true;
  }

  private cleanup(): void {
    const now = Date.now();
    for (const [ip, record] of this.clients.entries()) {
      if (now > record.resetTime) {
        this.clients.delete(ip);
      }
    }
  }

  reset(clientIp?: string): void {
    if (clientIp) {
      this.clients.delete(clientIp);
    } else {
      this.clients.clear();
    }
  }

  getStatus(clientIp: string): { requests: number; remaining: number; resetTime: number } | null {
    const client = this.clients.get(clientIp);
    if (!client) {
      return null;
    }

    return {
      requests: client.requests,
      remaining: Math.max(0, this.maxRequests - client.requests),
      resetTime: client.resetTime,
    };
  }
}